import React from 'react';
import cs from 'classnames';

import sharedCss from '../PaymentProcess/index.css';
import Stripe from '../Stripe';
import format from 'date-fns/format';
import {centTo$} from '~/misc/formatMoney';
import vipShownameTransfer from '~/components/pages/vipShownameTransfer.js';

import css from './index.css';

const endingPage = (props) => {
  let resultPage = false;
  let pendingPage = false;

  if (props.type === 'result') {
    pendingPage = false;
    resultPage = true;
  }
  if (props.type === 'pending') {
    pendingPage = true;
    resultPage = false;
  }
  const orderInfo = props.orderInfo;
  const payInfo = props.payInfo || {};
  const from = props.from || '';
  const hideField = props.hide || []
  // const payTotal = orderInfo.product.seat_num * orderInfo.product.pay_option.discount_price;
  return (
    <div className={css.wrap}>
      {resultPage
        && (<div className={css.header}>
          <div className={cs(css.pageTitle)}>
            <span className={cs(css.headerIcon, css.green)} />
            Payment Successful
          </div>
        </div>)
      }
      {(pendingPage
        && payInfo.error)
        && (<div className={css.header}>
          <div className={cs(css.pageTitle)}>
            <span className={cs(css.headerIcon, css.red)}>x</span>
            Failed Payment
          </div>
          <p className={cs(sharedCss.p, sharedCss.grey, sharedCss.opacity)}>
            The payment is failed, {payInfo.error}, please pay your order again or contact our support team.
          </p>
        </div>)
      }
      {(pendingPage
        && !payInfo.error)
        && (<div className={css.header}>
          <div className={cs(css.pageTitle)}>
            {/* <span className={cs(css.headerIcon)}>?</span> */}
            Payment Confirmation
          </div>
          <p className={cs(sharedCss.p, sharedCss.grey, sharedCss.opacity)}>
            {/* The payment is pending, please pay your order again. */}
          </p>
        </div>)
      }
      {
        (resultPage || (pendingPage && from == 'offcial' && payInfo && !payInfo.error))  && (<div>
           <div className={cs(css.partWrap)}>
        <div className={css.tit}>Billing Info</div>
        <ul className={css.productWrap}>
          <li className={css.tdWrap}>
            <div className={css.opacity4}>Name</div>
            <div className={cs(css.opacity8, css.textEnd)}>
              {`${orderInfo.billing_info.first_name } ${ orderInfo.billing_info.last_name}`}
            </div>
          </li>
          <li className={css.tdWrap}>
            <div className={css.opacity4}>Phone</div>
            <div className={cs(css.opacity8, css.textEnd)}>{orderInfo.billing_info.phone}</div>
          </li>
          <li className={css.tdWrap}>
            <div className={css.opacity4}>Email</div>
            <div className={cs(css.opacity8, css.textEnd)}>{orderInfo.billing_info.email}</div>
          </li>
          {/* {
            !hideField.includes("address") && 
            <li className={css.tdWrap}>
              <div className={css.opacity4}>Address</div>
              <div className={cs(css.opacity8, css.textEnd)}>
                {
                  `${orderInfo.billing_info.street_address }
                  ${ orderInfo.billing_info.state }
                  ${ orderInfo.billing_info.country }
                  ${ orderInfo.billing_info.zip}`
                }
              </div>
            </li>
          } */}
        </ul>
      </div>
      <div className={cs(css.partWrap)}>
        <div className={css.tit}>Payment Info</div>
        <ul className={css.productWrap}>
          <li className={css.thWrap}>
            <div>Product</div>
            <div>Price</div>
          </li>
          <li className={css.tdWrap}>
            <div className={css.opacity4}>
              Truckloads{' '}
              <span className={css.capitalize}>
              {
                orderInfo.product.pay_option && vipShownameTransfer[orderInfo.product.pay_option.grade_option.show_name]
              }
              </span>{' '}
              - Billed {orderInfo.product.pay_option && orderInfo.product.pay_option.show_name}
            </div>
            <div className={cs(css.opacity8, css.textEnd)}>
              ${orderInfo.product.pay_option && centTo$(orderInfo.product.pay_option.discount_price)}
            </div>
          </li>
          <li className={css.tdWrap}>
            <div className={css.opacity4}>Users x {orderInfo.product.seat_num}</div>
            <div className={cs(css.opacity8, css.textEnd)}>{' '}</div>
          </li>
          <li className={cs(css.thWrap, css.marginTop10)}>
            <div>First Time Total Payment</div>
            <div>${orderInfo.total_amount ? centTo$(orderInfo.total_amount) : 0}</div>
          </li>
        </ul>
      </div>
      <div className={cs(css.partWrap)}>
        <div className={css.thWrap}>Order Info</div>
        <ul className={css.productWrap}>
          <li className={css.tdWrap}>
            <div className={css.opacity4}>Order Number</div>
            <div className={cs(css.opacity8, css.textEnd)}>{orderInfo.order_id}</div>
          </li>
          <li className={css.tdWrap}>
            <div className={css.opacity4}>Order Time</div>
            <div className={cs(css.opacity8, css.textEnd)}>
              {orderInfo.created_time ? format(orderInfo.created_time, 'ddd MMM DD YYYY hh:mm:ss') : ''}
            </div>
          </li>
        </ul>
      </div>
        </div>)
      }
     
      {((pendingPage && orderInfo && payInfo && from !== 'offcial') || (pendingPage && from == 'offcial' && payInfo && !payInfo.error))
        && (<div className={cs(sharedCss.btnWrap)}>
          <Stripe
            from='a'
            email={props.email}
            amount={Number(orderInfo.product.total)}
            btnText={payInfo.loading ? 'loading' : 'Submit'}
            query={props.query}
            actionFn={props.actionFn}
          />
        </div>)
      }
    </div>
  );
};

export default endingPage;



// WEBPACK FOOTER //
// ./src/components/pages/EndingPage/index.js